import { Message } from "element-ui";
console.log(process.env)
// let baseURL = JSON.parse(process.env.api).api
let baseURL
if(process.env.PATH_TYPE === 'test') {
    baseURL = '//test-open.mamcharge.com'
} else if(process.env.PATH_TYPE === 'pre') {
    baseURL = '//pre-scop.mamcharge.com'
} else if(process.env.PATH_TYPE === 'prod') {
    baseURL = '//open.mamcharge.com'
} else {
    baseURL = '//dev-op.sharecharger.com/op'
}
require("es6-promise").polyfill
require("isomorphic-fetch")

const apiJson = {
    //登录注册
    loginbyemail: '/api/developer/login/loginbyemail',
    register: '/api/developer/register/add',
    findpwbyemail: '/api/developer/login/forgetpw/findpwbyemail',
    validresetparam: '/api/developer/login/forgetpw/validresetparam',
    resetPwByEmail: '/api/developer/login/forgetpw/resetPwByEmail',

    //应用
    listApps: '/api/applicaiton/common/listApps',
    openparampage: '/api/application/param/openparampage',
    getappparam: '/api/application/param/getappparam',
    saveparam: '/api/application/param/saveparam',
    updateparam: '/api/application/param/updateparam',
    savebasepage: '/api/application/page/savebasepage',
    savehomepage: '/api/application/page/savehomepage',
    savechargerpage: '/api/application/page/savechargerpage',
    getAppPage: '/api/application/page/getAppPage',
    updateBasePage: '/api/application/page/updateBasePage',
    updatgeHomePage: '/api/application/page/updatgeHomePage',
    updateChargerPage: '/api/application/page/updateChargerPage',
    getAppPay: '/api/application/pay/getAppPay',
    saveAppPay: '/api/application/pay/saveAppPay',
    updateAppPay: '/api/application/pay/updateAppPay',
    publishApp: '/api/applicaiton/common/publishApp',
    getApplyList: '/api/application/authsite/getApplyList',
    getCommercial: '/api/application/authsite/getCommercial',
    applySites: '/api/application/authsite/applySites',
    getCommercialSites: '/api/application/authsite/getCommercialSites',
    countUnreadApply: '/api/application/authsite/countUnreadApply',

    resendEmail: '/api/applicaiton/common/resendEmail',

    fileUpload: '/api/file/upload/oss/fileUpload'
}

const http = (url, data, method = 'POST') => {
    let token = localStorage.getItem('token')
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'token': token
        },
        method: method
    }
    options = data ? Object.assign(options, {body: JSON.stringify(data)}) :options
    return new Promise((resolve, reject) => {

        fetch(baseURL + url, options).then(res => {
            if(res.ok) {
                res.json().then(json => {
                    console.log(`%c 接口打印信息S`, 'background: #008000; color: #fff')
                    console.log('%s 接口地址', url)
                    console.log('%o 接口返回', json)
                    console.log('%o 接口参数', options)
                    console.log(`%c 接口打印信息E`, 'background: #008000; color: #fff')
                    if(json.code == 0 || json.code) {
                        resolve(json)
                    }else {
                        if(!json.errcode || json.errcode == 2) {
                            window.location.href = "./#/login"
                            Message.error('登录超时,请重新登录')
                        }else {
                            Message.error('接口异常')
                        }
                    }
                })
            } else {
                res.json().then(json => {
                    reject(json)
                    Message.error('接口调用错误')
                })
            }
        }).catch(res => {
            Message.error('接口调用错误')
            reject(res || '')
        })
        
    })
}
let filter = {}
filter.appType =  (val) => {
    let tmp = {
        '1': '社区',
        '2': '工具',
        '3': '物业App',
        '4': '生活服务'
    }
    return tmp[val] ? tmp[val] : '--'
}
filter.appStatus =  (val) => {
    let tmp = {
        '0': '未发布',
        '1': '已发布',
        '2': '禁用',
        '3': '软删除'
    }
    return tmp[val] ? tmp[val] : '--'
}

const GetQueryString = function (name) {
    var pattern = new RegExp("[?&]"+name+"\=([^&]+)", "g");  
    var matcher = pattern.exec(window.location.href);  
    var items = null;  
    if(null != matcher){  
        try{  
            items = decodeURIComponent(decodeURIComponent(matcher[1]));  
        }catch(e){  
            try{  
                items = decodeURIComponent(matcher[1]);  
            }catch(e){  
                items = matcher[1];  
            }  
        }  
    }  
    return items;  
}



export {
    http,
    apiJson,
    baseURL,
    filter,
    GetQueryString
} 



// WEBPACK FOOTER //
// ./src/utils/http.js